import styled from 'styled-components'
import { buttonPrimary, heading2 } from 'app/sofia/resources/theme/css'
import { font, bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  background: ${props => props.theme.palette.general.light};

  > div {
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
    padding: 70px 0 150px;
  }

  h2 {
    ${heading2};
    text-align: center;
    ${bp('sm')`
      font-size: 24px;
    `}
  }

  .item {
    width: 100%;
    padding: 0 50px;
    text-align: center;

    &__review,
    &__author {
      font: ${font('default', 'light', '20px/1.5')};
      ${bp('sm')`
        font: ${font('default', 'light', '18px/1.5')};
      `}
    }

    &__review {
      padding: 0 80px 20px;
    }

    &__rating {
      margin: 20px 0 10px;

      svg {
        padding: 0 5px;
      }
    }
  }

  .carousel {
    height: 200px;
  }

  > a {
    ${buttonPrimary}
    display: flex !important;
    background: transparent;
    border: 1px solid ${props => props.theme.palette.primary.alphaDark};
    color: ${props => props.theme.palette.primary.alphaDark};
    font-weight: ${props => props.theme.font.default.bold};
    margin: 20px auto 0;
    max-width: 225px;

    &:hover {
      background: ${props => props.theme.palette.primary.alphaDark};
      color: ${props => props.theme.palette.general.light};
    }
  }
`
